import { render, staticRenderFns } from "./RelatorioPages.vue?vue&type=template&id=af2d946a&"
import script from "./RelatorioPages.vue?vue&type=script&lang=js&"
export * from "./RelatorioPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports